import { css } from 'styled-components';
import { ButtonTypeRuleSets } from 'theme/Theme.types';

export const baseButtonRuleSets: Record<number, ButtonTypeRuleSets> = {
  0: {
    common: css`
      font-weight: ${props => props.theme.variables.fonts.weight.medium};
      text-transform: uppercase;
    `,
    disabled: css`
      color: ${props => props.theme.variables.colors.midGrey};
      background-color: ${props => props.theme.variables.colors.silver};
    `,
    enabled: css`
      color: #fff;
      background-color: ${props => props.theme.variables.colors.red};

      &:hover:not(:focus) {
        background-color: ${props => props.theme.variables.colors.midRed};
      }

      &:focus {
        background-color: ${props => props.theme.variables.colors.darkRed};
      }
    `,
  },
  1: {
    common: css`
      font-weight: ${props => props.theme.variables.fonts.weight.medium};
      text-transform: uppercase;
    `,
    disabled: css`
      color: ${props => props.theme.variables.colors.darkGrey};
    `,
    enabled: css`
      color: ${props => props.theme.variables.colors.red};
      background-color: transparent;

      &:hover:not(:focus) {
        background-color: rgba(0, 0, 0, 0.1);
      }

      &:focus {
        background-color: rgba(0, 0, 0, 0.2);
      }
    `,
  },
  2: {
    common: css`
      font-weight: ${props => props.theme.variables.fonts.weight.light};
      text-transform: lowercase;
    `,
    disabled: css`
      color: ${props => props.theme.variables.colors.midGrey};
      background-color: ${props => props.theme.variables.colors.silver};
    `,
    enabled: css`
      color: ${props => props.theme.variables.colors.black};
      background-color: transparent;

      &:hover:not(:focus) {
        background-color: rgba(0, 0, 0, 0.1);
      }

      &:focus {
        background-color: rgba(0, 0, 0, 0.2);
      }
    `,
  },
  3: {
    common: css`
      font-weight: ${props => props.theme.variables.fonts.weight.light};
      text-transform: lowercase;
      background-color: transparent;
    `,
    disabled: css`
      color: ${props => props.theme.variables.colors.midGrey};
    `,
    enabled: css`
      color: ${props => props.theme.variables.colors.black};
    `,
  },
};
